export default __webpack_public_path__ + "static/media/dashboard.62950c2f.svg";